import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import * as _ from "lodash";
import { Acesso } from 'src/app/core/acesso';
import { ToastService } from 'src/app/services/toast/toast.service';
import { Acoes } from '../../../../core/acoes';
import { MetaAcao } from '../../../../core/meta-acao';
import { MetaObjetivo } from '../../../../core/metaObjetivo';
import { MetaObjetivoService } from '../../../../services/metaObjetivo/meta-objetivo.service';

@Component({
    selector: 'formulario-acoes-metas-turma',
    templateUrl: './formulario-acoes-metas-turma.component.html',
    styleUrls: ['./formulario-acoes-metas-turma.component.css'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class FormularioAcoesMetasTurmaComponent implements OnInit {

    @Input() acoes: Acoes[];
    @Input() metas: MetaAcao[];
    @Input() meta: MetaAcao;
    @Input() index: number;
    @Input() perfilAcesso: Acesso;

    idRandomico = Math.random();

    constructor(private drc: ChangeDetectorRef,
                private toastService: ToastService,
                private metaObjetivoService: MetaObjetivoService) {
    }

    ngOnInit(): void {
    }

    ngAfterContentChecked(): void {
        this.drc.detectChanges();
    }

    deletar() {
        this.metas.splice(this.index, 1);
        this.toastService.showSucesso("Meta removida com sucesso.");
    }

    onValorChangeMeta(registro: any) {
        if (registro && registro.id) {
            const metaJaCadastrado = _.find(this.metas, (metasAcao: MetaAcao) => metasAcao.metaObjetivo?.id === registro.id);
            if (_.isEmpty(metaJaCadastrado)) {
                this.metaObjetivoService.getById(registro.id).subscribe((metaObjetivo: MetaObjetivo) => {
                    this.meta.metaObjetivo = metaObjetivo;
                })
            } else {
                this.toastService.showAlerta("Meta já adicionada.")
                this.metas.splice(this.index, 1);
                this.meta = new MetaAcao();
                this.metas.splice(this.index, 0, this.meta);
            }
        }
    }

}
